export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/indoor_lifestyle.b507d68.svg";